// Share sentences for a student invite. The topic is the newer exercise only.
// An empty topic on that exercise does not fall through to an older one.

const TOPIC_MAX = 80

const STARTED_SENTENCE = 'I just started learning with Quillnote, and I want to learn more! Please sign up here to link my account and see what I am learning'

const learnedSentence = (topic) =>
  `I just learned how to do ${topic} with Quillnote, and I want to learn more! Please sign up here to link my account and see what I am learning`

function timestampMs (value) {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (value instanceof Date) {
    const ms = value.getTime()
    return Number.isFinite(ms) ? ms : null
  }
  if (value && typeof value.toMillis === 'function') {
    try {
      const ms = value.toMillis()
      if (typeof ms === 'number' && Number.isFinite(ms)) return ms
    } catch (error) {
      return null
    }
  }
  if (value && typeof value.seconds === 'number' && Number.isFinite(value.seconds)) {
    const nanos = typeof value.nanoseconds === 'number' && Number.isFinite(value.nanoseconds)
      ? value.nanoseconds
      : 0
    return value.seconds * 1000 + nanos / 1e6
  }
  return null
}

function sanitizeShareTopic (topic) {
  if (typeof topic !== 'string') return ''
  const stripped = topic.replace(/[\r\n\u2028\u2029]+/g, '').trim()
  if (!stripped) return ''
  const chars = Array.from(stripped)
  if (chars.length <= TOPIC_MAX) return stripped
  return chars.slice(0, TOPIC_MAX).join('')
}

function topicOf (doc) {
  if (!doc || typeof doc.topic !== 'string') return ''
  return doc.topic
}

export function parentInviteShareText (topic) {
  const cleaned = sanitizeShareTopic(topic)
  return cleaned ? learnedSentence(cleaned) : STARTED_SENTENCE
}

// checkAnswer and explain are the newest doc of each kind, or null.
// A missing timestamp sorts older than a real one. When neither timestamp
// exists, there is no newer doc.
export function newerExerciseTopic (checkAnswer, explain) {
  const left = checkAnswer && typeof checkAnswer === 'object' ? checkAnswer : null
  const right = explain && typeof explain === 'object' ? explain : null
  if (!left && !right) return ''
  if (!left) return topicOf(right)
  if (!right) return topicOf(left)
  const leftMs = timestampMs(left.createdAt)
  const rightMs = timestampMs(right.createdAt)
  if (leftMs == null && rightMs == null) return ''
  if (rightMs == null) return topicOf(left)
  if (leftMs == null) return topicOf(right)
  if (rightMs > leftMs) return topicOf(right)
  return topicOf(left)
}
